import { Box, Fab, Tooltip } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useLocation, useNavigate } from 'react-router-dom';

export default function FormFloat() {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToForm = () => {
    const el = document.getElementById('requirement-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleClick = () => {
    if (location.pathname === '/') {
      scrollToForm();
    } else {
      navigate('/#requirement-form');
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        right: { xs: 12, sm: 16 },
        bottom: { xs: 76, sm: 84 },
        zIndex: 1500,
        pb: 'env(safe-area-inset-bottom)',
        pr: 'env(safe-area-inset-right)',
      }}
    >
      <Tooltip title="Requirement Form" placement="left">
        <Fab
          aria-label="Go to requirement form"
          onClick={handleClick}
          sx={{
            bgcolor: '#FF6B00',
            color: '#fff',
            '&:hover': { bgcolor: '#e66000' },
          }}
        >
          <AssignmentIcon />
        </Fab>
      </Tooltip>
    </Box>
  );
}
